import Vue from "vue";

export default {
    setQueryData: async ({commit}, queryData) => {
        commit('setQueryData', queryData)
    },
    setSelectedValidationProject: async ({commit}, selectedProject) => {
        if (selectedProject) {
            let config = {
                method: 'get',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v3-provisioning/event-validation-report',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {projectId: selectedProject._id},
            };
            return await Vue.prototype.$http(config)
                .then((response) => {
                    console.log('Get project response: ', response)
                    if (response.data.errorMessage) {
                        return Error(response.data.errorMessage)
                    } else if (response.data.type && response.data.type === 'error') {
                        return Error(response.data.message)
                    } else if (response.status === 200) {
                        commit('setSelectedValidationProject', response.data)
                    }
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setSelectedValidationProject', null)
            commit('setSelectedValidationDevice', null)
        }
    },
    setSelectedValidationDevice: async ({commit, state}, payload) => {
        if (payload) {
            console.log('On set validation device: ', payload)
            let config = {
                method: 'post',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-safetyanalysis/fetch-conflict-event',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: payload,
            };

            const firstResponse = await Vue.prototype.$http(config)
            console.log('Get conflict events response: ', firstResponse)


            if (firstResponse.data.errorMessage) {
                return Error(firstResponse.data.errorMessage)
            } else if (firstResponse.data.type && firstResponse.data.type === 'error') {
                return Error(firstResponse.data.message)
            }


            const {data, maxPages} = firstResponse.data
            let allData = [...data]

            for (let i = 1; i < maxPages; i++) {
                let nextPayload = {...payload}
                nextPayload.pageLimit = payload.pageLimit
                nextPayload.pageStart = i

                const nextConfig = {...config, data: nextPayload}
                const res = await Vue.prototype.$http(nextConfig)

                if (res.status === 200 && Array.isArray(res.data.data)) {
                    allData.push(...res.data.data)
                } else {
                    console.warn(`Page ${i} not loaded`)
                }
            }

            commit('setSelectedValidationDevice', payload.validationDevice)
            commit('setValidationData', allData)
            commit('updateSelectedEvent')

            return {
                success: true,
                total: allData.length,
                maxPages,
            }

        } else {
            commit('setSelectedValidationDevice', null)
            commit('setValidationData', [])
        }
    },
    updateEvents: async ({commit, state}, data) => {
        console.log('On update events: ', data)
        let config = {
            method: 'put',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-safetyanalysis/conflict-event-update-multiple',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data.payload,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Update conflict event: ', response)
                if (response.status === 200) {
                    commit('replaceConflictEvents', response.data)
                    commit('setSocketEventDeviceToSend', {
                        resId: data.dataDeviceId,
                        payload: response.data
                    }, {root: true})
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    setValidationTableHeaderData: async ({commit}, newData) => {
        commit('setValidationTableHeaderData', newData)
    },
    resetValidationTableHeaderData: async ({commit}) => {
        commit('resetValidationTableHeaderData')
    },
    selectEvent: async ({commit}, newEvent) => {
        commit('setSelectedEvent', newEvent)
    },
    callMergeChangedEvents: async ({commit}, changedEvents) => {
        await commit('replaceChangedEvents', changedEvents)
        await commit('updateSelectedEvent')
    }
}

